import Request from "../../../services/request";
import { SchemeNodeElement } from "@/helpers/constructors";

/**
 * Легенда условных обозначений (краны, клапаны, датчики и т.д.), из которых
 * состоят SVG узлов отопления — d_scheme_node_elements.
 */

const API = "/dictionary/scheme-node-elements";

export default {
  namespaced: true,
  state: {
    listEntries: [],
    listFamilies: [],
    loadingList: false,
    deleteModal: false,
    entry: new SchemeNodeElement(),
  },
  mutations: {
    setListEntries(state, array) {
      state.listEntries = Array.isArray(array) ? array : Object.values(array || {});
    },
    setListFamilies(state, array) {
      state.listFamilies = Array.isArray(array) ? array : Object.values(array || {});
    },
    setEntry(state, object) {
      state.entry = object || new SchemeNodeElement();
    },
    clearEntry(state) {
      state.entry = new SchemeNodeElement();
    },
    changeLoadingList(state, value) {
      state.loadingList = value;
    },
    deleteModalCommit(state, value) {
      state.deleteModal = value;
    },
  },
  actions: {
    stateModalAction({ commit }, value) {
      commit("deleteModalCommit", value);
    },
    clearEntry({ commit }) {
      commit("clearEntry");
    },
    async getListEntries({ commit }) {
      commit("changeLoadingList", true);
      try {
        const query = Request.modifyQuery([], ["*", "_file", "_family"]);
        const response = await Request.get(
          this.state.BASE_URL + `${API}${query}`
        );
        if (response && !response.isError) {
          commit("setListEntries", response.data);
        }
        return response;
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      } finally {
        commit("changeLoadingList", false);
      }
    },
    // Семейства для привязки к элементу — только верхний уровень дерева номенклатуры
    // (дети корня «Номенклатура»: «Котёл отопительный», «Краны шаровые» и т.д.)
    async getListFamilies({ commit, state }) {
      if (state.listFamilies.length) return;
      const query = Request.modifyQuery([], ["*"]);
      const response = await Request.get(
        this.state.BASE_URL + `/entity/nomenclatures-tree${query}`
      );
      if (response && !response.isError) {
        const flat = (response.data && response.data.flat_tree) || [];
        commit(
          "setListFamilies",
          flat
            .filter((leaf) => leaf.depth_level === 1)
            .map((leaf) => ({ id: leaf.id_family, name: leaf.name_leaf }))
            .sort((a, b) => a.name.localeCompare(b.name, "ru"))
        );
      }
    },
    async createEntry({ commit }, payload) {
      try {
        return await Request.post(this.state.BASE_URL + API, payload);
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      }
    },
    async updateEntry({ commit }, payload) {
      try {
        return await Request.put(
          this.state.BASE_URL + `${API}/${payload.id}`,
          payload
        );
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      }
    },
    async onSubmit({ state, commit, dispatch }, payload) {
      commit("changeLoadingList", true);
      try {
        const response = payload.id
          ? await dispatch("updateEntry", payload)
          : await dispatch("createEntry", payload);
        if (response && !response.isError) {
          await dispatch("getListEntries");
        }
        return response;
      } finally {
        commit("changeLoadingList", false);
      }
    },
    async deleteEntry({ commit, dispatch }, id) {
      commit("changeLoadingList", true);
      commit("deleteModalCommit", false);
      try {
        const response = await Request.delete(
          this.state.BASE_URL + `${API}/${id}`
        );
        if (response && !response.isError) {
          await dispatch("getListEntries");
        }
        return response;
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      } finally {
        commit("changeLoadingList", false);
      }
    },
  },
};
